import {
  avisoPendenciaIncompleta,
  EQUIPE_INCOMPLETA_CONFIRM,
  EQUIPE_INCOMPLETA_CONFIRM_SIMULACAO,
  EQUIPE_INCOMPLETA_INTRO_AFTER,
  EQUIPE_INCOMPLETA_INTRO_AFTER_SIMULACAO,
} from "../equipe-obra.constants";
import type { EquipeIncompletaDialogProps } from "./types-equipe-incompleta-dialog";

export function useEquipeIncompletaDialog({
  itens,
  obraRotulo,
  simulacao = false,
}: EquipeIncompletaDialogProps) {
  const papeis = itens ?? [];
  const pendentes = papeis.filter((papel) => !papel.adicionado).map((papel) => papel.nome);

  return {
    aberto: itens !== null,
    papeis,
    introDepois: simulacao
      ? EQUIPE_INCOMPLETA_INTRO_AFTER_SIMULACAO
      : EQUIPE_INCOMPLETA_INTRO_AFTER,
    confirmarLabel: simulacao ? EQUIPE_INCOMPLETA_CONFIRM_SIMULACAO : EQUIPE_INCOMPLETA_CONFIRM,
    aviso: avisoPendenciaIncompleta(pendentes, simulacao),
  };
}
